import cogoToast from "cogo-toast";
import moment from "moment";
import _ from "lodash";
import axios from "axios";
// API URLs from environment variables

// export const apiUrl = "https://api.newchart.care";
// export const apiUrl = "https://ncs-server.vercel.app";
// export const printApiUrl = "https://newchart-prints.vercel.app";


// export const apiUrl = "http://localhost:5000";
//export const printApiUrl = "http://localhost:3001";

// export const apiUrl =
//  "https://ncs-server-env-staging-radical-health.vercel.app";
// export const printApiUrl =
//  "https://newchart-prints-env-staging-radical-health.vercel.app";


export const apiUrl = process.env.REACT_APP_API_URL;
export const printApiUrl = process.env.REACT_APP_PRINT_API_URL;
export const alchemyUrl =
 "https://wc-api-service.1m4ef7p6cs5hq.ap-south-1.cs.amazonlightsail.com";


const CancelToken = axios.CancelToken;
let cancel;

export const fixUrlPrefix = (url) => {
  if (!url) return url;
  if (!url.includes("http")) {
    return apiUrl + url;
  } else {
    return url;
  }
};

export const niceDateTimeWithWeek = (date) => {
  return new Date(date).toLocaleTimeString("en-IN", {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const indianRupee = (amountPaise, fractionDigits) => {
  const amount = Number(amountPaise || 0) / 100;
  const fd = typeof fractionDigits === "number" ? fractionDigits : 2;
  return amount.toLocaleString("en-IN", {
    minimumFractionDigits: fd,
    maximumFractionDigits: fd,
    style: "currency",
    currency: "INR",
  });
};
export const niceAge = (dateOfBirth) => {
  const dob = new Date(dateOfBirth);
  const now = new Date();

  let age = now.getFullYear() - dob.getFullYear();

  if (now.getMonth() < dob.getMonth() || (now.getMonth() === dob.getMonth() && now.getDate() < dob.getDate())) {
    age--;
  }

  return age;
};

export const calculateRatesPaise = (
  foundCashRate,
  hasImplant,
  contractRateCapPaise,
  targetDeltaPaise,
  discount,
  gst,
  procedureChargeBeforeDisctPaise
) => {
  let effectiveBillablePaise = Math.min(foundCashRate.cashRatePaise + targetDeltaPaise, contractRateCapPaise);

  let finalBillablePaise = effectiveBillablePaise * (1 - discount / 100);

  let procedureChargeAfterDisctPaise = procedureChargeBeforeDisctPaise * (1 - discount / 100);

  let specialLessPaise = contractRateCapPaise - effectiveBillablePaise;

  let implantCostNetPaise = hasImplant
    ? (finalBillablePaise - procedureChargeAfterDisctPaise) / ((1 + gst / 100) * (1 - discount / 100))
    : 0;
  let implantCostShownPaise = hasImplant ? implantCostNetPaise + specialLessPaise : 0;

  return {
    effectiveBillablePaise,
    finalBillablePaise,
    procedureChargeAfterDisctPaise,
    specialLessPaise,
    implantCostNetPaise,
    implantCostShownPaise,
  };
};

export const areTwoDatesSame = (d1, d2) => {
  let dateInQuestion = new Date(d1);
  let compareTo = new Date(d2);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion === 0) {
    return true;
  } else {
    return false;
  }
};
export const niceQuantity = (qty, sub, unit, subunit) => {
  let integerQty = Math.floor(qty / sub);
  let fracQty = qty % sub;
  let str = `${integerQty} ${unit}`;
  if (fracQty) {
    str = str + ` + ${fracQty} ${subunit}`;
  }
  return str;
};

export const compareTwoObjects = (obj1, obj2) => {
  let stateObject = obj1; //new object
  let propObject = obj2; //old object
  for (var key in propObject)
    if (key in stateObject) {
      if (["createdAt", "_id", "createdById", "createdByName", "__v"].includes(key)) {
        continue;
      } else {
        propObject[key] = stateObject[key];
      }
    }
  for (var key2 in stateObject) {
    if (key2 === "vendorId") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "itemId") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "recvLocation") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "relatedPOId") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "surgeonId") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "validTo") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "validFrom") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "anaesthetistId") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "anaesthetistName") {
      propObject[key2] = stateObject[key2];
    }

    if (key2 === "cashRates") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "isCashless") {
      propObject[key2] = stateObject[key2];
    }
    if (key2 === "priceStaggering") {
      propObject[key2] = stateObject[key2];
    }
  }
  return propObject;
};

export const apiCallGet = async (path) => {
  let accessToken = localStorage.getItem("auth0jwt");
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }
  const resp = await axios.get(apiUrl + path, {
    credentials: "include",
    headers: { Authorization: accessToken },
  });
  return resp.data;
};

export const apiCallPostMultipartProgress = async (path, fd, callback) => {
  let accessToken = localStorage.getItem("auth0jwt");
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }
  const resp = await axios.post(apiUrl + path, fd, {
    credentials: "include",
    headers: {
      Authorization: accessToken,
      "content-type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => callback(progressEvent.loaded, progressEvent.total),
  });
  return resp.data;
};
export const apiCallPost = async (path, datum) => {
  let accessToken = localStorage.getItem("auth0jwt");
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }

  const resp = await axios.post(apiUrl + path, datum, {
    credentials: "include",
    headers: { Authorization: accessToken },
  });
  return resp.data;
};

export const apiCallPatch = async (path, datum) => {
  let accessToken = localStorage.getItem("auth0jwt");
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }

  const resp = await axios.patch(apiUrl + path, datum, {
    credentials: "include",
    headers: { Authorization: accessToken },
  });
  return resp.data;
};
export const apiCallPostProgress = async (path, datum, callback) => {
  let accessToken = localStorage.getItem("auth0jwt");
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }

  const resp = await axios.post(apiUrl + path, datum, {
    credentials: "include",
    headers: { Authorization: accessToken },
    onUploadProgress: (progressEvent) => callback(progressEvent.loaded, progressEvent.total),
  });
  return resp.data;
};

export const apiCallPostCancellable = async (path, datum) => {
  if (cancel !== undefined) {
    cancel();
  }
  try {
    let accessToken = localStorage.getItem("auth0jwt");
    if (!accessToken) {
      throw new Error("Access Token not found");
    }
    const res = await axios.post(apiUrl + path, datum, {
      credentials: "include",
      headers: { Authorization: accessToken },
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    });
    return res.data;
  } catch (err) {
    if (axios.isCancel(err)) {
    } else return err;
  }
};

export const initials = (txt) => {
  if (!txt) {
    return "NA";
  }
  return txt
    .split(" ")
    .map((n) => n[0])
    .join("");
};

export const niceDateV = (t, v) => {
  if (t === "date") {
    return niceDate(new Date(v));
  }
  return `${v}`;
};

export const niceDate = (date) => {
  return new Date(date).toLocaleDateString("en-IN", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const niceTime = (date) => {
  return new Date(date).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const niceDateTime = (date) => {
  return new Date(date).toLocaleTimeString("en-IN", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
export const niceDateTimeFull = (date) => {
  return new Date(date).toLocaleTimeString("en-IN", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const isInPastDate = (date, compareDate = new Date()) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion >= 0) {
    // compareDate or Future
    return true;
  } else {
    return false;
  }
};
export const isInPastDateStrict = (date, compareDate = new Date()) => {
  // if date in question is in the past wrt compareDate return true.
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion > 0) {
    // Future
    return true;
  } else {
    return false;
  }
};

export const isInFutureDate = (date, compareDate = new Date()) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion <= 0) {
    // compareDate or Future
    return true;
  } else {
    return false;
  }
};
export const isInFutureDateStrict = (date, compareDate = new Date()) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);
  if (compareTo - dateInQuestion < 0) {
    // Future
    return true;
  } else {
    return false;
  }
};

export const isDateToday = (date) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date();
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion === 0) {
    return true;
  } else {
    return false;
  }
};

export const yearFromNow = (d) => {
  const ageYr = moment().diff(moment(d), "year");
  if (ageYr > 0) {
    return [ageYr, ageYr === 1 ? "year" : "years"];
  }
  const ageMth = moment().diff(moment(d), "month");
  if (ageMth > 0) {
    return [ageMth, ageMth === 1 ? "month" : "months"];
  }
  const ageDay = moment().diff(moment(d), "day");
  if (ageDay > 0) {
    return [ageDay, ageDay === 1 ? "day" : "days"];
  }
  return ["NA", ""];
};

export const dateFromNow = (date, bool) => {
  return moment(date).fromNow(bool);
};
export const datesBetween = (date1, date2) => {
  let d1 = moment(date1);
  let d2 = moment(date2);
  return d1.from(d2, false);
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  cogoToast.success("Copied to clipboard", { position: "bottom-left" });
};

export const transposeDioptre = ({ sphere = 0, cylinder = 0, axis = 0, near = 0, pd = null }, focal = "Both") => {
  sphere = parseFloat(sphere);
  cylinder = parseFloat(cylinder);
  axis = parseFloat(axis);
  near = parseFloat(near);
  if (pd) {
    pd = parseInt(pd);
  }
  if (cylinder > 0) {
    sphere = sphere + cylinder;
    cylinder = -cylinder;
    axis = (axis + 90) % 180;
  }
  let dioptre = { sphere, cylinder, axis, near };
  let sphString = sphere.toFixed(2);
  let cylString = "";
  let addString = "";
  if (cylinder) {
    cylString = " x " + cylinder.toFixed(2) + " x " + axis;
  } else {
    cylString = " DS";
  }
  if (near) {
    addString = " Add " + near.toFixed(2);
  }

  let pdString = "";
  if (pd) {
    pdString = " with PD: " + pd + " mm";
  }
  let dioptreString = "";
  if (focal === "Both") {
    dioptreString = sphString + cylString + addString + pdString;
  }
  if (focal === "Near Only") {
    dioptreString = _.trimStart(addString + pdString);
  }
  if (focal === "Near Only" && !near) {
    dioptreString = "Plano" + pdString;
  }
  if (focal === "Far Only") {
    dioptreString = sphString + cylString + pdString;
  }

  dioptre["string"] = dioptreString;
  return dioptre;
};
export const replaceNullAndUndefined = (obj) => {
  for (const key in obj) {
    if (obj[key] === null || typeof obj[key] === "undefined") {
      obj[key] = "";
    }
  }
  return obj;
};
export const apiCallPostStreamingForAI = async (path, token, datum, onData, onEnd) => {
  let accessToken = token;
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }
  const resp = await fetch(alchemyUrl + path, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
    body: JSON.stringify(datum),
  });
  const reader = resp.body.getReader();
  reader.read().then(function pump({ done, value }) {
    if (done) {
      onEnd();
      return;
    }
    let utf8decoder = new window.TextDecoder();
    onData(utf8decoder.decode(value));
    return reader.read().then(pump);
  });
};
export const apiCallPostAI = async (accessToken, path, datum) => {
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }
  const resp = await axios.post(alchemyUrl + path, datum, {
    credentials: "include",
    headers: { Authorization: `${accessToken}` },
  });

  return resp.data;
};
export const apiCallWhisper = async (path, token, fd, callback) => {
  let accessToken = token;
  if (!accessToken) {
    cogoToast.error("Access token not found.");
    throw new Error("Access Token not found");
  }
  const resp = await axios.post(alchemyUrl + path, fd, {
    credentials: "include",
    headers: {
      "content-type": "multipart/form-data",
      Authorization: accessToken,
    },
    onUploadProgress: (progressEvent) => callback(progressEvent.loaded, progressEvent.total),
  });
  return resp.data;
};
/* 
nameOfFunction = async () => {
  try {
    cogoToast.loading("Text...", { position: "bottom-left" });
    let payload = {};
    let res = await apiCallPost(
      `/path/${this.props.authStore.prefix}/endpoint`,
      payload
    );
    cogoToast.success("Text", { position: "bottom-left" });

    this.setState({ lineItems: res });
  } catch (err) {
    cogoToast.error(
      "There was an error ACTION. Please check the console for more details.",
      { position: "bottom-left" }
    );
    console.log(err);
  }
};
 */
